import { render, staticRenderFns } from "./hotel_only_item.vue?vue&type=template&id=16752bf2&"
import script from "./hotel_only_item.vue?vue&type=script&lang=js&"
export * from "./hotel_only_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports